import { HexaV2ProgressColor, HexaV2TextColor } from '@/resources/enums/hexaV2'
import { OrderColorHex, OrderColors } from '@/resources/enums/orders'

export const IN_SEPARATION_SLA_MINUTES = 10
export const IN_SEPARATION_SLA_MINUTES_TURBO = 5
export const ON_GOING_SLA_MINUTES = 35
export const ON_GOING_SLA_MINUTES_TURBO = 15

export const OrderColor: {
  [key in OrderColors]: OrderColorHex
} = {
  [OrderColors.GREEN]: OrderColorHex.GREEN,
  [OrderColors.YELLOW]: OrderColorHex.YELLOW,
  [OrderColors.RED]: OrderColorHex.RED,
}

export const HexaV2OrderProgressColor: {
  [key in OrderColors]: HexaV2ProgressColor
} = {
  [OrderColors.GREEN]: HexaV2ProgressColor.SUCCESS,
  [OrderColors.YELLOW]: HexaV2ProgressColor.WARNING,
  [OrderColors.RED]: HexaV2ProgressColor.DANGER,
}

export const HexaV2OrderTextColor: {
  [key in OrderColors]: HexaV2TextColor
} = {
  [OrderColors.GREEN]: HexaV2TextColor.ON_SUCCESS_SECONDARY,
  [OrderColors.YELLOW]: HexaV2TextColor.ON_WARNING_SECONDARY,
  [OrderColors.RED]: HexaV2TextColor.ON_ERROR_SECONDARY,
}

export const HexaV2OrderColorTimeInSeparation: {
  [key in OrderColors]: number
} = {
  [OrderColors.GREEN]: 4,
  [OrderColors.YELLOW]: 7,
  [OrderColors.RED]: IN_SEPARATION_SLA_MINUTES,
}

export const HexaV2OrderColorTimeInSeparationTurbo: {
  [key in OrderColors]: number
} = {
  [OrderColors.GREEN]: 2,
  [OrderColors.YELLOW]: 3,
  [OrderColors.RED]: IN_SEPARATION_SLA_MINUTES_TURBO,
}

export const HexaV2OrderColorTimeOnGoing: {
  [key in OrderColors]: number
} = {
  [OrderColors.GREEN]: 17,
  [OrderColors.YELLOW]: 27,
  [OrderColors.RED]: ON_GOING_SLA_MINUTES,
}

export const HexaV2OrderColorTimeOnGoingTurbo: {
  [key in OrderColors]: number
} = {
  [OrderColors.GREEN]: 7,
  [OrderColors.YELLOW]: 11,
  [OrderColors.RED]: ON_GOING_SLA_MINUTES_TURBO,
}
